import React from 'react';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import { Spinner } from '.';

const StatBar = (props) => {
  const { label, value, data, color, isLoading, column, labelStyles, valueStyles, boxStyles } = props;
  return (
    <div className={column === undefined ? 'col-md-3' : column}>
      <div className="ibox" style={boxStyles === undefined ? {} : boxStyles}>
        <div className={`ibox-content spinkit${isLoading ? ' sk-loading' : ''}`}>
          <h5 style={labelStyles === undefined ? {} : labelStyles}>{label}</h5>
          <Spinner />
          <h2 style={valueStyles === undefined ? {} : valueStyles}>{value}</h2>
        </div>
        {
          data && (
            <div className="ibox-content no-padding">
              <div style={{ width: '100%', height: '60px' }}>
                <ResponsiveContainer>
                  <AreaChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                    <Area
                      type='monotone'
                      dataKey='value'
                      stroke={color}
                      strokeWidth={3}
                      fill={color}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default StatBar;
